import { cn } from '@/common/lib/cn/cn'
import { forwardRef } from 'react'
import type React from 'react'

export type TextareaType = {
    children?: React.ReactNode
    size?: 'sm' | 'md' | 'lg' | 'xl'
    emphasis?: 'neutral' | 'negative' | 'positive' | 'warning'
    disabled?: boolean
    className?: string
} & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'size'>

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaType>(
    ({ children, size = 'md', emphasis = 'neutral', disabled, className, ...props }, ref) => {
        const inputSizes = cn({
            'textarea-sm': size === 'sm',
            'textarea-md': size === 'md',
            'textarea-lg': size === 'lg',
            'textarea-xl': size === 'xl',
        })
        const inputClasses = cn(inputSizes, 'textarea', className)
        const labelClasses = cn(
            {
                'textarea-neutral': emphasis === 'neutral',
                'textarea-negative': emphasis === 'negative',
                'textarea-positive': emphasis === 'positive',
                'textarea-warning': emphasis === 'warning',
                'textarea-disabled': disabled,
            },
            inputClasses
        )

        return (
            <label className={labelClasses}>
                <textarea ref={ref} className={inputClasses} disabled={disabled} {...props}>
                    {children}
                </textarea>
            </label>
        )
    }
)

Textarea.displayName = 'Textarea'
